<template>
  <a :href="citationParsed.url" target="_blank" class="nms-citation-tag">
    <STooltip label="test" :content="tooltipContent" :placement="tooltipPosition">
      <STag style="cursor: pointer" :label="label" :type="type" />
      <template #content>
        <div class="nms-citation-card">
          <div class="nms-citation-card__domain">
            <img
              :src="getLogoByDomain(currentDomain)"
              alt="Alegra"
              style="width: 16px; height: 16px"
            />
            <span>
              {{ currentDomain }}
            </span>
          </div>
          <a class="nms-citation-card__title" target="_blank" :href="citationParsed.url">{{
            citationParsed.title
          }}</a>
          <p class="nms-citation-card__description">{{ citationParsed.description }}</p>
        </div>
      </template>
    </STooltip>
  </a>
</template>

<script setup lang="ts">
import { STag, STooltip } from '@alegradev/smile-ui-next'
import { HelperItem } from '@/micro/views/helpers/interfaces/Item'
import '../../../../node_modules/@alegradev/smile-ui-next/dist/style.css'
import AlegraMiniLogo from '@/micro/assets/logos/alegra-mini.svg'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    label: string
    type: 'primary' | 'slate' | 'rose' | 'amber' | 'green' | 'indigo'
    tooltipContent?: string
    tooltipPosition?: string
    citation: HelperItem | unknown
  }>(),
  {
    tooltipContent: '',
    tooltipPosition: 'top',
    citation: () => ({
      title: 'The title',
      type: 'article',
      tags: [],
      id: '1',
      description: 'The description',
      url: 'https://example.com',
    }),
  },
)

const logos = {
  alegra: AlegraMiniLogo,
  youtube: 'https://www.youtube.com/favicon.ico',
  default: 'https://www.google.com/favicon.ico',
}

const citationParsed = computed(() => {
  try {
    return typeof props.citation === 'string' ? JSON.parse(props.citation) : props.citation
  } catch (e) {
    console.error('Error parsing citation:', e)
    return props.citation
  }
})

const getDomain = (url: string) => {
  const domain = url.split('/')[2]
  return domain
}

const getLogoByDomain = (domain: string) => {
  const majorDomain = domain.split('.')[1]
  return logos[majorDomain] || logos.default
}

const currentDomain = computed(() => getDomain(citationParsed.value.url))
</script>

<style src="../../../../node_modules/@alegradev/smile-ui-next/dist/style.css" scoped></style>
<style lang="scss" scoped>
.nms-citation-card {
  display: flex;
  flex-direction: column;
  gap: 0.375rem; /* 1.5 * 0.25rem */
  padding: 0.75rem; /* 3 * 0.25rem */
  border: none;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem; /* 8px */
  background: white;
  width: 14.188em;

  &__domain {
    @apply text-xs font-normal text-slate-500;
    @apply flex gap-1.5 items-center;
  }

  &__title {
    @apply text-xs font-medium text-slate-900;
    display: -webkit-box; /* para compatibilidad con navegadores basados en WebKit */
    -webkit-line-clamp: 2; /* número máximo de líneas a mostrar */
    -webkit-box-orient: vertical; /* orientación del contenido */
    overflow: hidden; /* oculta el texto que se desborda del contenedor */
    text-overflow: ellipsis; /* agrega puntos suspensivos al final del texto truncado */
    width: 100%;
  }

  &__description {
    @apply text-xs font-normal text-slate-700;
    display: -webkit-box; /* para compatibilidad con navegadores basados en WebKit */
    -webkit-line-clamp: 2; /* número máximo de líneas a mostrar */
    -webkit-box-orient: vertical; /* orientación del contenido */
    overflow: hidden; /* oculta el texto que se desborda del contenedor */
    text-overflow: ellipsis; /* agrega puntos suspensivos al final del texto truncado */
    width: 100%;
  }
}

.sm-tag-next {
  :deep(span) {
    display: -webkit-box; /* para compatibilidad con navegadores basados en WebKit */
    -webkit-line-clamp: 1; /* número máximo de líneas a mostrar */
    -webkit-box-orient: vertical; /* orientación del contenido */
    overflow: hidden; /* oculta el texto que se desborda del contenedor */
    text-overflow: ellipsis; /* agrega puntos suspensivos al final del texto truncado */
    width: 100%;
  }
}
</style>
